import { Stack, TextField } from "@mui/material";
import React from "react";
import RHFErrorMessage from "./RHFErrorMessage";

export const InputValidationRules = {
  text: {
    email: {
      value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
      message: "Invalid Email",
    },
    password: {
      min: { value: 8, message: "Minimum 8 characters required" },
      max: { value: 15, message: "Exceeded 15 characters limit" },
      pattern: {
        value:
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/g,
        message: "Enter strong password",
      },
    },
    maxRange: { value: 100, message: "Exceeded 100 character limit" },
    midRange: { value: 50, message: "Exceeded 50 characters limit" },
  },
  textArea: {
    maxRange: { value: 300, message: "Exceed 300 character limit" },
  },
};

const propsToRTFMapper = ({
  required,
  min,
  max,
  pattern,
  minLength,
  maxLength,
  validate
}) => {
  return { required, min, max, pattern, minLength, maxLength, validate };
};

export const RHFTextField = (props) => {
  const { register, errors } = props;
  return (
    <Stack>
      <TextField
        {...{ ...props, required: false, min: null, max: null, pattern: null }}
        inputProps={{ ...register(props.name, propsToRTFMapper(props)) }}
      />
     <RHFErrorMessage errors={errors} name={props.name} />
    </Stack>
  );
};
